import React from "react";
import { WhatsappLogo, Check, Checks } from "@phosphor-icons/react";

/**
 * Mockup animado de disparo em massa via WhatsApp.
 * Loop de ~5s. CSS puro (sem JS state), leve, sem asset externo.
 *
 * Estrutura:
 *  - "Telefone" com header verde do WhatsApp
 *  - 4 mensagens saindo em sequência com check duplo (enviado)
 *  - Badge inferior contando quantas foram entregues (também animado)
 */
export default function WhatsappBroadcastMockup() {
  const msgs = [
    { to: "Camila (+55 11 9****-1204)", txt: "Olá Camila! Sua fatura vence hoje 💸", delay: 0 },
    { to: "Rodrigo (+55 21 9****-8891)", txt: "Rodrigo, seu Pix de R$ 89,90 está pronto ✅", delay: 1.1 },
    { to: "Beatriz (+55 31 9****-3320)", txt: "Bea, novo funil no ar. Confere 👀", delay: 2.2 },
    { to: "João (+55 47 9****-5501)", txt: "João, plano renovado com sucesso ⚡", delay: 3.3 },
  ];

  return (
    <div
      className="wa-mockup relative w-full aspect-square rounded-sm border border-[var(--border)] overflow-hidden"
      data-testid="whatsapp-broadcast-mockup"
      style={{
        background:
          "linear-gradient(180deg, rgba(15,23,20,1) 0%, rgba(8,12,10,1) 100%)",
      }}
    >
      {/* grão / textura sutil */}
      <div
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, #25D366 0%, transparent 40%), radial-gradient(circle at 80% 90%, #128C7E 0%, transparent 50%)",
        }}
      />

      {/* header estilo whatsapp */}
      <div className="relative z-10 flex items-center gap-3 px-5 py-4 border-b border-white/5 backdrop-blur-sm">
        <div className="w-10 h-10 rounded-full bg-[#25D366]/20 border border-[#25D366]/40 flex items-center justify-center">
          <WhatsappLogo size={22} color="#25D366" weight="fill" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-white truncate">
            Disparo MercadoPagu · Meta API
          </div>
          <div className="text-[10px] text-[#25D366] flex items-center gap-1 mt-0.5">
            <span className="w-1.5 h-1.5 rounded-full bg-[#25D366] animate-pulse" />
            enviando em tempo real
          </div>
        </div>
        <div className="text-[10px] font-mono text-white/40">1.284 leads</div>
      </div>

      {/* área de mensagens */}
      <div className="relative z-10 px-4 py-4 space-y-2 h-[calc(100%-140px)] overflow-hidden">
        {msgs.map((m, i) => (
          <div
            key={i}
            className="wa-bubble opacity-0"
            style={{ animationDelay: `${m.delay}s` }}
          >
            <div className="max-w-[90%] ml-auto bg-[#005C4B] rounded-lg rounded-tr-sm px-3 py-2 shadow-[0_2px_8px_rgba(0,0,0,0.3)]">
              <div className="text-[10px] text-white/50 font-mono mb-1 truncate">
                → {m.to}
              </div>
              <div className="text-[13px] text-white leading-snug">{m.txt}</div>
              <div className="flex items-center justify-end gap-1 mt-1 text-[10px] text-white/60">
                <span>
                  {new Date(Date.now() + i * 60000).toLocaleTimeString("pt-BR", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>
                <Checks size={12} weight="bold" color="#53BDEB" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* footer com contador */}
      <div className="absolute bottom-0 left-0 right-0 z-10 border-t border-white/5 bg-black/40 backdrop-blur-md px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Check size={14} weight="bold" color="#25D366" />
          <span className="text-[11px] text-white/80 font-mono">
            <span className="wa-counter">1.284</span> entregues em&nbsp;
            <span className="text-[var(--accent)] font-semibold">4,2s</span>
          </span>
        </div>
        <div className="text-[10px] text-white/40 font-mono uppercase tracking-wide">
          ao vivo
        </div>
      </div>

      <style>{`
        .wa-bubble {
          animation: waBubbleIn 5s cubic-bezier(0.16, 1, 0.3, 1) infinite;
          transform: translateY(20px);
        }
        @keyframes waBubbleIn {
          0%   { opacity: 0; transform: translateY(20px); }
          8%   { opacity: 1; transform: translateY(0); }
          85%  { opacity: 1; transform: translateY(0); }
          95%  { opacity: 0; transform: translateY(-6px); }
          100% { opacity: 0; transform: translateY(20px); }
        }
        .wa-counter {
          display: inline-block;
          animation: waCount 5s linear infinite;
        }
        @keyframes waCount {
          0%   { color: #fff; }
          20%  { color: #25D366; }
          100% { color: #fff; }
        }
        .wa-mockup:hover .wa-bubble {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
}
